import { useState } from "react";
import { Spin } from "antd";
import defaultImg from "../../../assets/images/No_image_available.png"

const CardImageItem = ({ fileName }) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => setLoading(false);
  const handleImageError = () => setLoading(false);

  return (
    <div className="image-container" style={{ position: "relative", textAlign: "center" }}>
      {loading && (
        <div className="loading-spinner mt-3">
          <p>Chargement, merci de patienter...</p>
          <Spin size="large" className="text-center" />
        </div>
      )}

      <img
        src={fileName ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${fileName}` : defaultImg}
        alt="Image"
        className="img-fluid"
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{
          display: loading ? "none" : "block",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default CardImageItem;
